import { SDLABS_CLIENT_VERSION } from "@globals";
import Icon from "@lib/common/components/Icon/Icon";
import { Box, Group, Text } from "@mantine/core";

export default function PageFooter() {
  return (
    <Box pt="3rem" mb="1rem">
      <Group align="center" justify="center" gap={7} mt="3rem">
        <Text size="xs" fw={500} c="dimmed" inline>
          SDLabs® v{SDLABS_CLIENT_VERSION}
          <span style={{ paddingInline: 7 }}>·</span>Made with
        </Text>
        <Icon name="heart" color="red.6" variant="solid" size="0.9rem" />
        <Text size="xs" fw={500} c="dimmed" inline>
          Atinary Technologies<span style={{ paddingInline: 7 }}>·</span>Lausanne, Switzerland
        </Text>
      </Group>
    </Box>
  );
}
